// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3fdVH","head":"ProcedureTableInfo_head__3pyH7"};